<template>
  <!-- eslint-disable max-len -->
  <div class="px-4 sm:px-6 py-5 space-y-8">
    <BaseVeeForm ref="form" :action="updateEmailCampaign">
      <template #default="formProps">
        <div class="space-y-6 sm:space-y-5">
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">Schedule Information</h3>
            <p class="mt-1 max-w-2xl text-sm text-gray-500">
              Select when to start sending the email message.
            </p>
          </div>

          <div class="space-y-8">
            <div class="space-y-2">
              <div>
                <BaseFormRadio
                  v-model="emailCampaignData.start_now"
                  name="starts_at"
                  label="Send immediately"
                  :checked-value="true"
                  :disabled="!canUpdate || formProps.isPending"
                />
              </div>
              <div>
                <BaseFormRadio
                  v-model="emailCampaignData.start_now"
                  name="starts_at"
                  label="Start sending at"
                  :checked-value="false"
                  :disabled="!canUpdate || formProps.isPending"
                />
                <div class="pl-7">
                  <BaseFormTextFieldWithValidator
                    v-if="emailCampaignData.start_now === false"
                    v-model="emailCampaignData.starts_at"
                    :validator="{
                      name: 'starts at',
                      vid: 'starts_at',
                      rules: {
                        required: true,
                      },
                    }"
                    :field="{
                      id: 'sms_campaign_starts_at',
                      inputType: 'datetime-local',
                    }"
                    :disabled="!canUpdate || formProps.isPending"
                    class="max-w-lg"
                  />
                </div>
              </div>
            </div>

            <div
              v-if="missingFilters"
              class="rounded-md bg-yellow-50 border border-yellow-200 p-4 max-w-lg"
            >
              <div class="flex">
                <div class="flex-shrink-0">
                  <!-- Heroicon name: solid/exclamation -->
                  <svg
                    class="h-5 w-5 text-yellow-400"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </div>
                <div class="ml-3">
                  <h3 class="text-sm font-medium text-yellow-800">Attention needed</h3>
                  <div class="mt-2 text-sm text-yellow-700">
                    <p>
                      You have no filters applied. Emails will be delivered to all your contacts.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="flex gap-3">
              <BaseButton
                primary
                :disabled="!canUpdate || formProps.isPending || formProps.invalid"
              >
                Save
              </BaseButton>
              <BaseButton
                type="button"
                primary
                outline
                :disabled="!canUpdate || formProps.isPending || formProps.invalid"
                @click="
                  () => {
                    formProps.submit().then((response) => {
                      return launch();
                    });
                  }
                "
              >
                Save &amp; Launch
              </BaseButton>
            </div>
          </div>
        </div>
      </template>
    </BaseVeeForm>
  </div>
</template>

<script>
import { accountActiveEmailCampaignsClient } from '@/api/clients';
import moment from 'moment';

export default {
  props: {
    emailCampaign: {
      type: Object,
      required: true,
    },
    canUpdate: Boolean,
    onUpdate: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      emailCampaignData: {
        start_now: typeof this.emailCampaign?.starts_at !== 'string',
        starts_at: this.emailCampaign?.starts_at
          ? moment.utc(this.emailCampaign.starts_at).local().format('YYYY-MM-DDTHH:mm')
          : null,
      },
    };
  },
  computed: {
    missingFilters() {
      if (!this.emailCampaign.filter) {
        return true;
      }

      return Object.keys(this.emailCampaign.filter).length === 0;
    },
  },
  methods: {
    updateEmailCampaign() {
      return this.onUpdate(
        this.emailCampaignData.start_now
          ? { start_now: true }
          : {
              starts_at: moment(this.emailCampaignData.starts_at).utc().format('YYYY-MM-DD HH:mm'),
            }
      );
    },
    async launch() {
      try {
        await accountActiveEmailCampaignsClient.store(this.emailCampaign.account_id, {
          email_campaign_id: this.emailCampaign.id,
        });

        this.$router.push({
          name: this.$route.name,
          params: this.$route.params,
          query: {
            ...this.$route.query,
            email_campaign_updated: new Date().getTime(),
          },
        });

        this.$emit('close-modal');

        this.$modal.show({
          component: () =>
            import(
              '@/components/EmailCampaign/ViewEmailCampaignDialog/ViewEmailCampaignDialog.vue'
            ),
          props: {
            emailCampaignId: this.emailCampaign.id,
          },
          on: {},
          hideEvent: 'close',
        });

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
